export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-vietnamese-700-normal.woff2?1d8e5ae5ae97c0dd1c30dad2a9fd0298";